<template>
    <div>
    <el-card style="height: 100vh;" v-loading="loadingStatus">
        <div class="nav-header">
            <div class="item active">
               门店授权绑定
            </div>
        </div>
        <div class="line-block">
            <h4>门店信息</h4>
        </div>
        <div class="avatar-text">
            <img src="../../assets/images/defaultPlist.png" alt="">
            <div class="text">
                <div class="store">
       <span style="color: rgba(0,0,0,0.85);">门店：</span>{{storeObj.name }}
                </div>
                <div class="store store-address ">
                    <span style="color: rgba(0,0,0,0.85);">门店地址： </span>{{ storeObj.address }}
                </div>  
                <div class="extra">
                    <span @click="AuthToken" v-if="showAuthToken">商户授权</span>
                    <span v-if="isNotBind" @click="bingdStore">绑定门店</span>
                    <span v-if="!showAuthToken && !isNotBind" >授权绑定完成！</span>
           <el-button v-if="!showAuthToken && !isNotBind" @click="unbind" style="margin-left:12px" type="danger" icon="el-icon-delete" circle>去解绑</el-button>
                   <div>
                   </div>
                </div>
            </div>
        </div>
        <el-dialog
   title="绑定店铺"
  :visible.sync="dialogVisible"
  width="900px"
  >
 <el-table
  ref="singleTable"
   @current-change="handleCurrentChange"
   highlight-current-row
  v-loading="tableLoadng"
    :data="tableData"
    border
    max-height="50vh"
    style="width: 100%">
    <!-- <el-table-column
    type="selection"
    align="center"
     >
    </el-table-column> -->
    <el-table-column
      prop="shopname"
      align="center"
      label="店铺名称">
    </el-table-column>
        <el-table-column
      prop="branchname"
      align="center"
      label="分店名称">
    </el-table-column>
    <el-table-column
    align="center"
      prop="cityname"
      label="所在城市"
     >
     
    </el-table-column>
        <el-table-column
    align="center"
      prop="shopaddress"
      label="门店地址"
     >
     
    </el-table-column>
    
  </el-table>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button :loading="bindLoading" style="background:#f59a23;color:#fff" @click="bindBtn">确 定</el-button>
  </span>
</el-dialog>
    </el-card>
    </div>
</template>

<script >
export default{
    data(){
        return{
            storeObj:{
                name:'--',
                code:'--',
                address:'--'
            },
            loadingStatus:false,
            id:'',
            bindLoading:false,
            currentRow:'',
            tableData:[],
            tableLoadng:false,
            dialogVisible:false,
            isNotBind:false,
            merchantName:localStorage.getItem('merchantName'),
            merchantCode:localStorage.getItem('merchantCode'),
            baseInfo:[],
            appAuthToken:"",
            poiId:'',
            showAuthToken:false
        }
    },
    methods:{
       async bindBtn(){
        if(this.currentRow){
            let data={...this.currentRow,id:this.id}
            let res=await this.$http.post('meituanBeijixingAuthToken/update',data)
            if(res.data.code==200){
                  this.dialogVisible = false
               this.$notify({
          title: '成功',
          message: '保存成功',
          type: 'success'
        });
        this.getBindStatus()
            }else{
                this.$message.error(res.data.message)
            }
        }else{
            this.$message.info('请选择门店')
        }

            
        },
          handleCurrentChange(val) {
        this.currentRow = val;
      },
      async  getBindStatus(){
        this.loadingStatus=true
        let res=await this.$http.post('meituanBeijixingAuthToken/queryOne',{merchantCode:this.merchantCode})
        this.loadingStatus=false
        if(res.data.code==200){
            if(res.data.data){  // /判断没有值显示 商户授权，
                this.showAuthToken=false
                 this.id=res.data.data.id
                if(res.data.data.openShopUuid){ // 有值的话判断openShopUuid是否有值 没值显示绑定门店
                    this.isNotBind=false //有值显示授权绑定完成，给个取消授权的按钮
                   let {shopname,branchname,cityname,shopaddress}=res.data.data
                   this.storeObj.name=shopname+(branchname)
                   this.storeObj.address=cityname+shopaddress
                }else{
                             this.storeObj={
                name:'--',
                code:'--',
                address:'--'
            }
                     this.isNotBind=true
                }
            }else{
                                          this.storeObj={
                name:'--',
                code:'--',
                address:'--'
            }
                this.showAuthToken=true
                this.isNotBind=false
            }
        }else{
            this.$message.error(res.data.message)
        }
        },
        getBaseInfo(){
            this.$http.post('/merchantBaseInfo/queryOne',{merchantCode:this.merchantCode}).then(res=>{
                this.baseInfo=res.data.data
            })
        },
        // 授权
      async  AuthToken(){
        let res=await this.$http.post('meituanAppAuthToken/auth',{merchantCode:this.merchantCode})
       if(res.data.code==200){
        window.open(res.data.data)
       }else{
        this.$message.error((res.data.message))
       }
        },
        //绑定门店
      async  bingdStore(){
        this.dialogVisible=true
         this.tableLoadng=true
        let res=await this.$http.post('meituanAppAuthToken/queryAuthStoreList',{merchantCode:this.merchantCode})
        this.tableLoadng=false
        this.tableData=res.data.data.data
        if(res.data.data.data.length>0){
            this.$refs.singleTable.setCurrentRow(res.data.data.data[0]);
        }
        },
        // 解绑
       async unbind(){
        let res=await this.$http.post('meituanBeijixingAuthToken/delete',{id:this.id})
        if(res.data.code==200){
           this.$notify({
          title: '成功',
          message: '已解除绑定',
          type: 'success'
        });
        this.getBindStatus()
        }else{
            this.$message.error(res.data.message)
        }
        },
    },
    created(){
        this.getBindStatus()
        // this.getBaseInfo()
    },
    mounted(){
        var base=this.getBindStatus
        window.addEventListener('visibilitychange',function(){
            base()
})
    },
    beforeDestroy(){
         var base=this.getBindStatus
        window.removeEventListener('visibilitychange',
        function(){
            base()
})
    },
}
</script>

<style lang="scss" scoped>
/deep/.el-table__body{
 tr.current-row>td{
    background-color: #f59a23;
    color: #fff;
}
}

.nav-header{
    display: flex;
    margin-bottom: 17px;
    .item{
        padding: 0 16px;
        height: 21px;
        padding: 12px 16px;
        margin-right: 32px;
        font-size: 14px;
        color: #333;
        cursor: pointer;
    }
    .item.active{
       border-bottom: 2px solid #ffbd00;
       font-weight: 500;
       color: #000;
}
}
.line-block{
   
    h4{
        font-size: 14px;
    padding-left: 8px;
    margin-top: unset;
    margin-bottom: 14px;
    border-left: 4px solid rgb(255, 189, 0);
    text-align: left;
    color: rgb(34,34,34);
    font-weight: 500;


    }
}
.avatar-text{
    height: 100px;
    display: flex;
    img{
        height: 100px;
        width: 100px;
        display: block;
        margin-right: 14px;
    }
    .text{
        display: flex;
    flex-direction: column;
    text-align: left;
    width: 90%;
    font-size: 14px;
    .store{
        height: 22px;
    margin-bottom: 8px;
    color: rgba(0, 0, 0, 0.65);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    }
    .store.store-address{
        margin-bottom: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    }
    .extra{
        display: flex;
        align-items: center;
        span{
            color: rgba(255, 96, 0,1);
            cursor: pointer;
        }
        span:hover{
            color: rgba(255,96,0,0.85);
        }
    }
    }
}
span.token{
    margin-left: 12px;
    color: rgba(0,0,0,0.65);
    width: 500px;overflow: hidden;
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>